import { render, staticRenderFns } from "./CreatedOrders.vue?vue&type=template&id=0ea6716e&scoped=true&"
import script from "./CreatedOrders.vue?vue&type=script&lang=js&"
export * from "./CreatedOrders.vue?vue&type=script&lang=js&"
import style0 from "./CreatedOrders.vue?vue&type=style&index=0&id=0ea6716e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea6716e",
  null
  
)

export default component.exports